import React from 'react'
import clsx from 'clsx'
import { Box } from '@node-space/ui-components'

export const EarnSummaryItemVariant = {
  DEFAULT: 'default',
  LARGE: 'large',
} as const

export type EarnSummaryItemVariant =
  (typeof EarnSummaryItemVariant)[keyof typeof EarnSummaryItemVariant]

export interface EarnSummaryItemProps {
  label: string
  value: string
  variant?: EarnSummaryItemVariant
}

export const EarnSummaryItem = ({
  label,
  value,
  variant = EarnSummaryItemVariant.DEFAULT,
}: EarnSummaryItemProps) => {
  const isLarge = variant === EarnSummaryItemVariant.LARGE

  return (
    <Box flexCol justify="center" gap={4} className="flex-1 min-w-0">
      <p className="text-label text-foreground-prominent">{label}</p>
      <p
        className={clsx('text-foreground-prominent', {
          'text-h1': isLarge,
          'text-h3': !isLarge,
        })}
      >
        {value}
      </p>
    </Box>
  )
}
